import { createBrowserRouter, Outlet, redirect, RouterProvider } from 'react-router-dom';

import AcceptedPlansPage from 'components/acceptedPlans/AcceptedPlansPage';
import Admissions from 'components/admin/admissions/Admissions';
import EditAdmissionPrompt from 'components/admin/admissions/EditAdmissionPrompt';
import EditAICriteriaSet from 'components/admin/admissions/EditAICriteriaSet';
import AIPrompts from 'components/admin/aiPrompts/AIPrompts';
import EditAIPrompt from 'components/admin/aiPrompts/EditAIPrompt';
import Attributes from 'components/admin/attributes/Attributes';
import EditAttribute from 'components/admin/attributes/EditAttribute';
import EditAttributeValue from 'components/admin/attributes/EditAttributeValue';
import BulkImportDetail from 'components/admin/bulkImports/BulkImportDetail';
import BulkImportHistory from 'components/admin/bulkImports/BulkImportHistory';
import BulkImportNew from 'components/admin/bulkImports/BulkImportNew';
import Classifications from 'components/admin/classifications/Classifications';
import Clients from 'components/admin/clients/Clients';
import ConfigureCareOptions from 'components/admin/clients/configureCareOptions/ConfigureCareOptions';
import EditClient from 'components/admin/clients/EditClient';
import EditImportConfiguration from 'components/admin/clients/importConfigurations/EditImportConfiguration';
import ProductAccess from 'components/admin/clients/productAccess/ProductAccess';
import CoordinationRequests from 'components/admin/coordinationRequests/CoordinationRequests';
import DemoEnvSetup from 'components/admin/demoEnvSetup/DemoEnvSetup';
import DischargeReasons from 'components/admin/dischargeReasons/DischargeReasons';
import EditDischargeReason from 'components/admin/dischargeReasons/EditDischargeReason';
import EditFeatureFlag from 'components/admin/featureFlags/EditFeatureFlag';
import FeatureFlags from 'components/admin/featureFlags/FeatureFlags';
import EditGroup from 'components/admin/groups/EditGroup';
import Groups from 'components/admin/groups/Groups';
import EditGroupType from 'components/admin/groupTypes/EditGroupType';
import GroupTypes from 'components/admin/groupTypes/GroupTypes';
import ImportHistory from 'components/admin/importHistory/ImportHistory';
import ImportStatusDetails from 'components/admin/importHistory/ImportStatusDetails';
import LinkedRecords from 'components/admin/linkedRecords/LinkedRecords';
import EditLocation from 'components/admin/locations/EditLocation';
import Locations from 'components/admin/locations/Locations';
import QhinConfiguration from 'components/admin/locations/qhinConfiguration/QhinConfiguration';
import EditQuestionTemplate from 'components/admin/questionTemplates/EditQuestionTemplate';
import QuestionTemplates from 'components/admin/questionTemplates/QuestionTemplates';
import Summaries from 'components/admin/summaries/Summaries';
import AdminEditPermissions from 'components/admin/users/AdminEditPermissions';
import AdminUserPreferences from 'components/admin/users/AdminUserPreferences';
import EditUser from 'components/admin/users/EditUser';
import Users from 'components/admin/users/Users';
import EditWorkspacePrompt from 'components/admin/workspacePrompts/EditWorkspacePrompt';
import WorkspacePrompts from 'components/admin/workspacePrompts/WorkspacePrompts';
import AdmissionSlideout from 'components/admissions/AdmissionSlideout';
import AdmissionsPage from 'components/admissions/AdmissionsPage';
import AllPatientsPage from 'components/allPatients/AllPatients';
import AuthError from 'components/AuthError';
import CoordinateLayout from 'components/coordinate/CoordinateLayout';
import CoordinateRequestsPage from 'components/coordinate/requests/CoordinateRequestsPage';
import CoordinateIndex from 'components/coordinateRequest/CoordinateIndex';
import CoordinateRequestSubmittedPage from 'components/coordinateRequest/CoordinateRequestSubmittedPage';
import DenialListPage from 'components/denialList/DenialListPage';
import { DISCHARGE_CALENDAR_ROUTES, DISCHARGE_CALENDAR_VIEWS } from 'components/dischargeCalendar/constants';
import DayView from 'components/dischargeCalendar/dayView/DayView';
import DischargeCalendarPage from 'components/dischargeCalendar/DischargeCalendarPage';
import ListView from 'components/dischargeCalendar/listView/ListView';
import MonthView from 'components/dischargeCalendar/monthView/MonthView';
import TwoWeekView from 'components/dischargeCalendar/twoWeekView/TwoWeekView';
import WeekView from 'components/dischargeCalendar/weekView/WeekView';
import External from 'components/External';
import { INBOUND_REFERRALS_ROUTES } from 'components/inboundReferrals/constants';
import EditInboundReferralPage from 'components/inboundReferrals/EditInboundReferralPage';
import InboundReferralPage from 'components/inboundReferrals/InboundReferralPage';
import InboundReferralsListPage from 'components/inboundReferrals/InboundReferralsListPage';
import BusinessDevelopmentContainer from 'components/insights/careTransitions/businessDevelopment/BusinessDevelopmentContainer';
import NetworkPerformanceContainer from 'components/insights/careTransitions/networkPerformance/NetworkPerformanceContainer';
import ReferralsContainer from 'components/insights/careTransitions/referrals/ReferralsContainer';
import ReferralsDashboard from 'components/insights/careTransitions/referrals/ReferralsDashboard';
import { Routes as InsightsRoutes } from 'components/insights/constants';
import InsightsContainer from 'components/insights/InsightsContainer';
import ActivitiesPerPatientWeekDetail from 'components/insights/layout/details/activitiesPerPatientWeek/ActivitiesPerPatientWeekDetail';
import AverageLengthOfStayDetail from 'components/insights/layout/details/averageLengthOfStay/AverageLengthOfStayDetail';
import OlioEngagementScoreDetail from 'components/insights/layout/details/olioEngagementScore/OlioEngagementScoreDetail';
import ReadmissionRateDetail from 'components/insights/layout/details/readmissionRate/ReadmissionRateDetail';
import ResponseTimeDetail from 'components/insights/layout/details/responseTime/ResponseTimeDetail';
import TotalDischargesDetail from 'components/insights/layout/details/totalDischarges/TotalDischargesDetail';
import MetricsDashboard from 'components/insights/layout/MetricsDashboard';
import AddPatientPage from 'components/intake/AddPatientPage';
import CoordinatePatientPage from 'components/intake/CoordinatePatientPage';
import EditPatientPage from 'components/intake/EditPatientPage';
import MainLayout from 'components/layouts/MainLayout';
import LoggedOut from 'components/LoggedOut';
import UserNotificationPreferences from 'components/notificationPreferences/UserNotificationPreferences';
import ConcurrentReviewsPage from 'components/patient/concurrentReview/ConcurrentReviewsPage';
import FilesPage from 'components/patient/FilesPage';
import PatientPage from 'components/patient/Patient';
import PatientStoryPage from 'components/patient/PatientStoryPage';
import PortfolioPage from 'components/portfolio/Portfolio';
import ReferralPage from 'components/referral/ReferralPage';
import ReferralsListPage from 'components/referrals/ReferralsListPage';
import RootProviders from 'components/Root';
import HomeRedirect from 'components/router/HomeRedirect';
import PermissionRedirect from 'components/router/PermissionRedirect';
import ProtectedRoute from 'components/router/ProtectedRoute';
import NewSummarizationPage from 'components/summarization/NewSummarizationPage';
import ViewSummarizationPage from 'components/summarization/ViewSummarizationPage';
import SummarizationsListPage from 'components/summarizations/SummarizationsListPage';
import ThemeProvider from 'components/ThemeProvider';
import { Flags } from 'constants/flags';
import { EpisodeProvider } from 'context/episode';
import { SelectedLocationEpisodeProvider } from 'context/locationEpisode';
import { useProfile } from 'context/profile';
import { AuthorizationProvider } from 'context/review/authorization';
import { ReferralProvider } from 'context/review/referral';
import { EscalationTypes } from 'models/Escalation';
import { PERMISSIONS, PRODUCT_ACCESSORS } from 'models/Profile';

function AdminGuard() {
  const { profile } = useProfile();
  return (
    <ProtectedRoute deny={!profile.isAdmin}>
      <Outlet />
    </ProtectedRoute>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootProviders />,
    children: [
      {
        index: true,
        element: <HomeRedirect />,
      },
      {
        path: '/auth/callback',
        element: <></>,
      },
      {
        path: '/external',
        element: <External />,
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            element: (
              <ProtectedRoute accessor={PRODUCT_ACCESSORS.careCoordinationEnabled}>
                <Outlet />
              </ProtectedRoute>
            ),
            children: [
              {
                path: '/patients/:episodeId/*',
                element: (
                  <EpisodeProvider>
                    <SelectedLocationEpisodeProvider>
                      <ReferralProvider>
                        <AuthorizationProvider>
                          <Outlet />
                        </AuthorizationProvider>
                      </ReferralProvider>
                    </SelectedLocationEpisodeProvider>
                  </EpisodeProvider>
                ),
                children: [
                  {
                    path: '*',
                    element: <PatientPage />,
                    children: [
                      {
                        path: '*',
                        element: <PatientStoryPage />,
                        children: [
                          {
                            path: 'authorization/:authorizationId/*',
                            element: null,
                          },
                        ],
                      },
                      {
                        path: 'concurrent-reviews',
                        element: <ConcurrentReviewsPage />,
                        children: [
                          {
                            path: ':authorizationId/*',
                            element: null,
                          },
                        ],
                      },
                      {
                        path: 'referrals',
                        element: <ReferralPage />,
                        children: [
                          {
                            path: ':referralId/*',
                            element: null,
                          },
                        ],
                      },
                      {
                        path: 'files',
                        element: <FilesPage />,
                      },
                    ],
                  },
                  {
                    path: 'edit',
                    element: <EditPatientPage />,
                  },
                ],
              },
              {
                path: '/all-patients',
                element: <AllPatientsPage />,
              },
              {
                path: '/contracted-health-plans',
                element: <AcceptedPlansPage />,
              },
              {
                path: '/referrals',
                element: <ReferralsListPage />,
                children: [
                  {
                    path: ':referralId/*',
                    element: null,
                  },
                ],
              },
              {
                path: '/insights/referrals',
                element: <ReferralsContainer />,
                children: [
                  {
                    index: true,
                    element: <ReferralsDashboard />,
                  },
                ],
              },
              {
                path: '/insights/post-discharge',
                element: <NetworkPerformanceContainer />,
              },
              {
                path: '/insights/business-development',
                element: <BusinessDevelopmentContainer />,
              },
              {
                path: '/insights',
                element: <InsightsContainer />,
                children: [
                  {
                    index: true,
                    element: <MetricsDashboard />,
                  },
                  {
                    path: InsightsRoutes.OLIO_ENGAGEMENT_SCORE,
                    element: <OlioEngagementScoreDetail />,
                  },
                  {
                    path: InsightsRoutes.READMISSION_RATE,
                    element: <ReadmissionRateDetail />,
                  },
                  {
                    path: InsightsRoutes.AVERAGE_LENGTH_OF_STAY,
                    element: <AverageLengthOfStayDetail />,
                  },
                  {
                    path: InsightsRoutes.TOTAL_DISCHARGES,
                    element: <TotalDischargesDetail />,
                  },
                  {
                    path: InsightsRoutes.ACTIVITIES_PER_PATIENT_PER_WEEK,
                    element: <ActivitiesPerPatientWeekDetail />,
                  },
                  {
                    path: InsightsRoutes.PRIORITIES_NOTE_RESPONSE,
                    element: <ResponseTimeDetail escalationType={EscalationTypes.PriorityNote} />,
                  },
                  {
                    path: InsightsRoutes.ESCALATIONS_RESPONSE,
                    element: <ResponseTimeDetail escalationType={EscalationTypes.Escalation} />,
                  },
                  {
                    path: '*',
                    loader: async () => redirect('/insights'),
                  },
                ],
              },
              {
                path: '/coordinate',
                element: <CoordinateLayout />,
                children: [
                  { index: true, element: <CoordinateIndex /> },
                  { path: 'submitted', element: <CoordinateRequestSubmittedPage /> },
                  { path: 'requests', element: <CoordinateRequestsPage /> },
                  { path: ':id', element: <CoordinatePatientPage /> },
                ],
              },
              {
                path: '/connect-patients',
                loader: async () => redirect('/coordinate'),
              },
              {
                path: '/patients',
                element: <PortfolioPage />,
              },
              {
                path: '/patients/new',
                element: <AddPatientPage />,
              },
              {
                path: '/preferences',
                element: <UserNotificationPreferences />,
              },
            ],
          },
          {
            path: '/admissions',
            element: (
              <ProtectedRoute accessor={PRODUCT_ACCESSORS.admissionsManagementEnabled}>
                <AdmissionsPage />
              </ProtectedRoute>
            ),
            children: [
              {
                path: ':admissionId',
                element: <AdmissionSlideout />,
                children: [
                  {
                    index: true,
                    loader: ({ params }) => redirect(`/admissions/${params.admissionId}/criteria`),
                  },
                  { path: 'criteria', element: null },
                  { path: 'summary', element: null },
                  { path: 'files', element: null },
                ],
              },
            ],
          },
          {
            path: '/admissions/denial-list',
            element: (
              <ProtectedRoute
                accessor={[
                  PRODUCT_ACCESSORS.inboundReferralsEnabled,
                  PERMISSIONS.denialListView,
                  PERMISSIONS.denialListItemView,
                ]}>
                <DenialListPage />
              </ProtectedRoute>
            ),
          },
          {
            path: '/summarizations',
            element: (
              <ProtectedRoute accessor={PRODUCT_ACCESSORS.olioSummarizationEnabled}>
                <Outlet />
              </ProtectedRoute>
            ),
            children: [
              {
                index: true,
                element: <SummarizationsListPage />,
              },
              {
                path: 'new',
                element: <NewSummarizationPage />,
              },
              {
                path: ':summarizationId',
                element: <ViewSummarizationPage />,
              },
            ],
          },
          {
            path: INBOUND_REFERRALS_ROUTES.BASE,
            element: (
              <ProtectedRoute accessor={PRODUCT_ACCESSORS.inboundReferralsEnabled} flag={Flags.InboundReferrals}>
                <Outlet />
              </ProtectedRoute>
            ),
            children: [
              {
                index: true,
                element: <InboundReferralsListPage />,
              },
              {
                path: ':workflowId',
                element: <InboundReferralPage />,
              },
              {
                path: ':workflowId/edit',
                element: <EditInboundReferralPage />,
              },
            ],
          },
          {
            path: DISCHARGE_CALENDAR_ROUTES.BASE,
            element: (
              <ProtectedRoute accessor={PRODUCT_ACCESSORS.dischargeCalendarEnabled}>
                <DischargeCalendarPage />
              </ProtectedRoute>
            ),
            children: [
              {
                path: DISCHARGE_CALENDAR_VIEWS.WEEK,
                element: <WeekView />,
              },
              {
                path: DISCHARGE_CALENDAR_VIEWS.TWO_WEEK,
                element: <TwoWeekView />,
              },
              {
                path: DISCHARGE_CALENDAR_VIEWS.MONTH,
                element: <MonthView />,
              },
              {
                path: DISCHARGE_CALENDAR_VIEWS.DAY,
                element: <DayView />,
              },
              {
                path: DISCHARGE_CALENDAR_VIEWS.LIST,
                element: <ListView />,
              },
            ],
          },
          {
            path: '/admin',
            element: <AdminGuard />,
            children: [
              { path: 'demo-env-setup', element: <DemoEnvSetup /> },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminClientView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'clients', element: <Clients /> },
                  { path: 'clients/collaborations', element: <Clients /> },
                  { path: 'clients/import-configurations', element: <Clients /> },
                  { path: 'clients/import-configurations/new', element: <EditImportConfiguration /> },
                  { path: 'clients/import-configurations/:id/edit', element: <EditImportConfiguration /> },
                  { path: 'clients/new', element: <EditClient /> },
                  { path: 'clients/:id/edit', element: <EditClient /> },
                  { path: 'clients/:id/group-types/edit', element: <ConfigureCareOptions /> },
                  { path: 'clients/:id/product-access', element: <ProductAccess /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminUserView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'users', element: <Users /> },
                  { path: 'users/new', element: <EditUser /> },
                  { path: 'users/:id/edit', element: <EditUser /> },
                  { path: 'users/:id/preferences', element: <AdminUserPreferences /> },
                  { path: 'users/:id/permissions', element: <AdminEditPermissions /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminCoordinateRequestView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [{ path: 'coordination-requests', element: <CoordinationRequests /> }],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminQuestionTemplateView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'question-templates', loader: () => redirect('/admin/question-templates/progress') },
                  { path: 'question-templates/progress', element: <QuestionTemplates /> },
                  { path: 'question-templates/discharge', element: <QuestionTemplates /> },
                  { path: 'question-templates/:type/new', element: <EditQuestionTemplate /> },
                  { path: 'question-templates/:type/:id/edit', element: <EditQuestionTemplate /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminDischargeReasonView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'discharge-reasons', element: <DischargeReasons /> },
                  { path: 'discharge-reasons/new', element: <EditDischargeReason /> },
                  { path: 'discharge-reasons/:id/edit', element: <EditDischargeReason /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminGroupView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'groups', element: <Groups /> },
                  { path: 'groups/new', element: <EditGroup /> },
                  { path: 'groups/:id/edit', element: <EditGroup /> },
                  { path: 'locations', element: <Locations /> },
                  { path: 'locations/new', element: <EditLocation /> },
                  { path: 'locations/:id/edit', element: <EditLocation /> },
                  {
                    path: 'locations/:id/qhin-configuration',
                    element: (
                      <ProtectedRoute accessor={PERMISSIONS.adminQhinConfigurationView}>
                        <QhinConfiguration />
                      </ProtectedRoute>
                    ),
                  },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminLinkedRecordView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [{ path: 'shared-records', element: <LinkedRecords /> }],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminGroupTypeView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'group-types', element: <GroupTypes /> },
                  { path: 'group-types/new', element: <EditGroupType /> },
                  { path: 'group-types/:id/edit', element: <EditGroupType /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminAttrView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'attributes', element: <Attributes /> },
                  { path: 'attributes/values', element: <Attributes /> },
                  { path: 'attributes/new', element: <EditAttribute /> },
                  { path: 'attributes/:id/edit', element: <EditAttribute /> },
                  { path: 'attributes/values/new', element: <EditAttributeValue /> },
                  { path: 'attributes/values/:id/edit', element: <EditAttributeValue /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminAIPromptView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'ai-prompts', element: <AIPrompts /> },
                  { path: 'ai-prompts/new', element: <EditAIPrompt /> },
                  { path: 'ai-prompts/:id/edit', element: <EditAIPrompt /> },
                  { path: 'workspace-prompts', element: <WorkspacePrompts /> },
                  { path: 'workspace-prompts/new', element: <EditWorkspacePrompt /> },
                  { path: 'workspace-prompts/:id/edit', element: <EditWorkspacePrompt /> },
                  { path: 'generated-summaries', element: <Summaries /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute
                    accessor={[
                      PERMISSIONS.adminAIPromptView,
                      PERMISSIONS.adminAICriteriaView,
                      PERMISSIONS.adminDenialListView,
                    ]}
                    strictMode={false}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  {
                    path: 'admissions',
                    children: [
                      {
                        index: true,
                        element: (
                          <PermissionRedirect
                            routes={[
                              { permission: PERMISSIONS.adminAIPromptView, path: '/admin/admissions/prompts' },
                              { permission: PERMISSIONS.adminAICriteriaView, path: '/admin/admissions/criteria' },
                              { permission: PERMISSIONS.adminDenialListView, path: '/admin/admissions/denial-lists' },
                            ]}
                          />
                        ),
                      },
                      { path: 'prompts', element: <Admissions /> },
                      { path: 'criteria', element: <Admissions /> },
                      { path: 'denial-lists', element: <Admissions /> },
                    ],
                  },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminAIPromptView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'admissions/prompts/new', element: <EditAdmissionPrompt /> },
                  { path: 'admissions/prompts/:id/edit', element: <EditAdmissionPrompt /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminAICriteriaView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'admissions/criteria/new', element: <EditAICriteriaSet /> },
                  { path: 'admissions/criteria/:id/edit', element: <EditAICriteriaSet /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminFeatureFlagView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'feature-flags', element: <FeatureFlags /> },
                  { path: 'feature-flags/:name/edit', element: <EditFeatureFlag /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminImportedPatientView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'import-history', element: <ImportHistory /> },
                  { path: 'import-history/:id/status-details', element: <ImportStatusDetails /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminBulkImportView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'bulk-import', element: <BulkImportHistory /> },
                  { path: 'bulk-import/new', element: <BulkImportNew /> },
                  { path: 'bulk-import/:id', element: <BulkImportDetail /> },
                ],
              },
              {
                element: (
                  <ProtectedRoute accessor={PERMISSIONS.adminClassificationView}>
                    <Outlet />
                  </ProtectedRoute>
                ),
                children: [
                  { path: 'plans', element: <Classifications /> },
                  { path: 'plan-types', element: <Classifications /> },
                  { path: 'episode-types', element: <Classifications /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/',
    element: (
      <ThemeProvider>
        <Outlet />
      </ThemeProvider>
    ),
    children: [
      {
        path: '/logged-out',
        element: <LoggedOut />,
      },
      {
        path: '/error',
        element: <AuthError />,
      },
    ],
  },
  {
    path: '*',
    index: true,
    loader: async () => redirect('/patients'),
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
